export default __webpack_public_path__ + "static/media/background_image.a8212217.jpg";